import React, { useState, useEffect } from 'react';
import styles from '../../styles/InfoCollapse.module.css';
import { useTheme } from '../../context/ThemeContext';

const InfoCollapse = ({ children }) => {
  // Ensure it starts collapsed
  const [isCollapsed, setIsCollapsed] = useState(true);
  const { isDarkMode } = useTheme();

  // Force initial state to be collapsed
  useEffect(() => {
    setIsCollapsed(true);
  }, []);

  const toggleCollapse = () => {
    setIsCollapsed(prevState => !prevState);
  };

  return (
    <div className={`${styles.infoCollapse} ${isCollapsed ? styles.collapsed : ''} ${isDarkMode ? styles.dark : ''}`}>
      <button
        className={styles.infoCollapseToggle}
        onClick={toggleCollapse}
        aria-expanded={!isCollapsed}
      >
        <span>Información del examen</span>
        <span className={styles.infoCollapseIcon}>
          {isCollapsed ? '+' : '−'}
        </span>
      </button>
      <div className={styles.infoCollapseContent}>
        {children}
      </div>
    </div>
  );
};

export default InfoCollapse;